import { CommonUtilities }  from '../../commonUtils';

export default class scrapingServices  {

    static getDSPList() {
        var url = 'client/getClientDSP';
        return CommonUtilities.getData(url);
    }
}